// React
import React from "react";
import PropTypes from "prop-types";

// Functions
import { TableCell } from "./TableBodyCells";
import isEmpty from "../../validation/is-empty";
import { translate } from "../../utils/translation";

TableFilteredTotal.propTypes = {
  columns: PropTypes.array,
  tableArray: PropTypes.array,
  filters: PropTypes.array,
  isTotalDisabled: PropTypes.bool,
};

export function TableFilteredTotal(props) {
  const { columns, tableArray } = props;
  const { filters } = props;
  const { isTotalDisabled } = props;

  if (isTotalDisabled || isEmpty(tableArray)) {
    return null;
  }

  //Do not display this row if there are filters selected in the table
  if (isEmpty(filters)) {
    return null;
  }

  const displayRow = BuildTotalRow(
    columns,
    tableArray,
    translate("Filtered Total")
  );

  return (
    <b>
      <div className={"pct-row-page-total"}>{displayRow}</div>
    </b>
  );
}

TableTotal.propTypes = {
  columns: PropTypes.array,
  tableArray: PropTypes.array,
  isTotalDisabled: PropTypes.bool,
};

export function TableTotal(props) {
  const { columns, tableArray } = props;
  const { isTotalDisabled } = props;

  if (isTotalDisabled || isEmpty(tableArray)) {
    return null;
  }

  //Remove the total row from the table array
  let rows = tableArray.filter((x) => x.tableRowType !== "TOTAL");

  const displayRow = BuildTotalRow(columns, rows, translate("Page Total"));

  return (
    <b>
      <div className={"pct-row-total"}>{displayRow}</div>
    </b>
  );
}

function BuildTotalRow(columns, tableArray, displayText) {
  const displayRow = [];

  columns.forEach((cell) => {
    let value = "";
    if (cell.type === "DESCRIPTION") {
      value = displayText;
    }
    if (cell.isTotalled) {
      value = cell.generateTotal(tableArray, cell.key);
    }

    displayRow.push(
      <TableCell
        key={cell.key}
        value={value}
        width={cell.width}
        cell={cell}
        setModal={() => null}
      />
    );
  });
  return displayRow;
}
